<template>
    <div>
        <loading v-if="loading" :size="2" message="Загружаем активность пользователя..."></loading>
        <div class="steamline" v-else>
            <div  class="sl-item" v-for="log in logsPage.logs">
                <div class="sl-left"> <i class="fa fa-code-fork"></i> </div>
                <div class="text-muted">{{log.diffForHumans}} ({{log.date}} в {{log.time}})</div>
                <div class="desc">{{log.text}} <a href="#" @click.prevent="showOrderDetail(log.objectId)">№{{log.objectId}}</a></div>
            </div>
        </div>
        <b-pagination class="mb-0" size="md" :total-rows="logsPage.paginator.total_count" v-model="page" :per-page="logsPage.paginator.limit">
        </b-pagination>
    </div>
</template>

<script>
  import getUserLogsQuery from './../../gql/queries/getUserLogs.graphql'
  export default {
    props: ['userId'],
    data () {
      return {
        page: 1,
        logsPage: {
          paginator: {
            total_count: 10,
            limit: 10
          }
        },
        loading: false
      }
    },
    methods: {
      showOrderDetail (id) {
        this.$store.dispatch('showOrderDetail', id)
      }
    },
    apollo: {
      logsPage: {
        query: getUserLogsQuery,
        variables () {
          return {
            userId: this.userId,
            page: this.page
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading) {
          this.loading = isLoading
        },
        update: (data) => data
      }
    }
  }
</script>
<style>
    .avatar-box .img-avatar {
        width: 200px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// Timeline.vue?7b8c19dd